import { CheckCircleOutlined } from '@ant-design/icons'
import { Button, ButtonProps, Typography } from 'antd'

export interface InPageNotificationContentProps {
  title: string
  message: string
  buttonText?: string
  buttonProps?: ButtonProps
  type?: 'success'
  notificationBehavior?: 'blocking' | 'non-blocking'
}

const ICONS_RECORD: Record<NonNullable<InPageNotificationContentProps['type']>, JSX.Element> = {
  success: <CheckCircleOutlined className="[&>svg]:fill-success-active [&>svg]:text-2xl" />
}

export function InPageNotificationContent({ title, message, buttonText, buttonProps, type }: InPageNotificationContentProps) {
  return (
    <div className="flex w-full flex-col items-center gap-y-2">
      {type && ICONS_RECORD[type]}

      <Typography className="text-lg font-bold">{title}</Typography>

      <Typography.Text type="secondary" className="text-center">
        {message}
      </Typography.Text>

      {buttonText && (
        <Button type="primary" className="w-full" {...buttonProps}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}
